import type { WireArticleBlock } from '../../../api/types'
import { InlineContent } from '../common/InlineContent'
import { PortionMark } from '../common/PortionMark'

type Block = Extract<WireArticleBlock, { type: 'list' }>

export function ListBlock({ block }: { block: Block }) {
  const items = block.items.map((item) => (
    <li key={item.id} className="article-body text-fg">
      <InlineContent children={item.children} />
    </li>
  ))

  return (
    <div>
      <PortionMark classification={block.classification} disseminationControls={block.disseminationControls} />
      {block.style === 'unordered' ? (
        <ul className="list-disc space-y-1 pl-5">{items}</ul>
      ) : (
        <ol className="list-decimal space-y-1 pl-5">{items}</ol>
      )}
    </div>
  )
}
